import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteProvider = ({ providerId }: { providerId: number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Providers/DeleteProvider/${providerId}`);
};

type QueryFnType = typeof deleteProvider;

type UseDeleteProviderOptions = {
  providerId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteProvider = ({ config }: UseDeleteProviderOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: AxiosError<any>) => {
      if (error.response && error.response.data && error.response.data.message) {
        const responseMessage = error.response?.data.message;
        console.log(responseMessage);
        addNotification(responseMessage.toString(), 500);
        setIsNotificationVisible(true);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(["getAllProviders"]);
      addNotification(`Ο Πάροχος Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteProvider,
  });
};
